<template>
  <div id="app">
    <vheader></vheader>
    <router-view />
    <vfooter></vfooter>
  </div>
</template>

<script>
import vfooter from "@/components/vfooter";
import vheader from "@/components/vheader";
import Vue from "vue";
//Vue.component('vfooter',footer)
//Vue.component('vheader',header)
export default {
  name: "App",
  components: {
    vfooter,
    vheader
  },
  methods: {
    is_mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  mounted() {
    if (this.is_mobile()) {
      var str = location.href;
      var n = str.replace("www", "web");
      location.href = n;
    }
    var url = location.href;
    if (url == "http://www.sealyyg.com/#/home") {
      location.href = "http://www.sealyyg.com/#/";
    }
  }
};
</script>

<style>
body {
  margin: 0;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue